import { Injectable } from '@angular/core';
import { IStorageExpirationItem } from '@hub/interfaces/IStorageExpirationItem';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  constructor() {
    this.storage = sessionStorage;
  }

  private storage: Storage;
  private EXPIRE_PREFIX: string = 'EXPIRATION_';

  public get(key: string, noExpire?: boolean): any {
    var validKey = this.checkAndGetKey(key, noExpire);
    if (!validKey) {
      return null;
    }

    var keyItem = this.storage.getItem(validKey);

    if (keyItem == undefined || keyItem == 'undefined') {
      return '';
    }

    var itemFromStorage = JSON.parse(keyItem);

    if (this.isExpirationKey(validKey)) {
      return this.isItemValid(validKey, itemFromStorage)
        ? itemFromStorage.Value
        : null;
    } else {
      return itemFromStorage;
    }
  }

  public set(key: string, value: any): void;
  public set(key: string, value: any, expiration: Date): void;
  public set(key: string, value: any, expiration?: Date): void {
    if (!expiration) {
      this.storage.setItem(key, JSON.stringify(value));
    } else {
      this.setWithExpiration(this.EXPIRE_PREFIX + key, expiration, value);
    }
  }

  public remove(key: string): void {
    var validKey = this.checkAndGetKey(key);
    if (!validKey) {
      return;
    }

    this.storage.removeItem(validKey);
  }

  public exist(key: string): boolean {
    var validKey = this.checkAndGetKey(key);

    if (this.isExpirationKey(validKey)) {
      var itemFromStorage = JSON.parse(this.storage.getItem(validKey));

      return this.isItemValid(validKey, itemFromStorage);
    }

    return !!validKey;
  }

  public getExpiration(key: string): Date {
    var validKey = this.checkAndGetKey(key);

    if (this.isExpirationKey(validKey)) {
      var itemFromStorage = JSON.parse(this.storage.getItem(validKey));

      return itemFromStorage.Expiration;
    }

    return undefined;
  }

  public clear(): void {
    this.storage.clear();
  }

  private setWithExpiration(key: string, expiration: Date, value: any): void {
    var itemToStorage: IStorageExpirationItem = {
      Expiration: expiration.toString(),
      Value: value
    };
    this.storage.setItem(key, JSON.stringify(itemToStorage));
  }

  private checkAndGetKey(key: string, noExpire?: boolean): string {
    var keys = Object.keys(this.storage);
    var resultKey: string = null;
    var expirationKey = this.EXPIRE_PREFIX + key;

    keys.some(value => {
      if (value == key || (noExpire != true && value == expirationKey)) {
        resultKey = value;

        return true;
      }

      return false;
    });

    return resultKey;
  }

  private isExpirationKey(key: string): boolean {
    return key && key.indexOf(this.EXPIRE_PREFIX) >= 0;
  }

  private isItemValid(key: string, item: IStorageExpirationItem): boolean {
    if (new Date(item.Expiration).getTime() > new Date().getTime()) {
      return true;
    }
    this.remove(key);

    return false;
  }
}
